module.exports = __webpack_public_path__ + "static/hero2-680f444f3f5d5eb2c934c36dc682743e.png";